<div class="modal-dialog activity-instructions-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<div class="goreact-modal-header">
			<h4 class="modal-title">{{ activity.name }}</h4>
			<button type="button" class="close-btn" (click)="close()" aria-label="Close">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body">
			<h5 class="activity-details-title">{{'activity-info_activity-details' | translate}}</h5>
			<activity-info
				[activity]="activity"
				[hideRecordingInstructions]="shouldHideRecordingInstructions()"
				[hideSourceMedia]="shouldHideRecordingInstructions()"
				[isOnDashboard]="true"
			></activity-info>
		</div>
		<div class="goreact-modal-footer">
			<button id="activity-instructions-dialog-close" class="primary-btn" (click)="close()" translate="common_close" data-cy="common_close"></button>
		</div>
	</div>
</div>
